import { render, staticRenderFns } from "./SkinCard.vue?vue&type=template&id=5145a826&scoped=true&"
import script from "./SkinCard.vue?vue&type=script&lang=ts&"
export * from "./SkinCard.vue?vue&type=script&lang=ts&"
import style0 from "./SkinCard.vue?vue&type=style&index=0&id=5145a826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5145a826",
  null
  
)

export default component.exports